import { computeEffectiveTable, generateInvoice, legacyTimeslotsToPricingPolicies, TDR, toLuxon } from 'tdr-common';
import getReservationInvoice from '../api/getReservationInvoice';

export const getNewInvoiceForCancellation = async ({
	restaurant,
	table,
	reservation,
	basePolicies
}: {
	restaurant: TDR.Restaurant;
	table: TDR.Table;
	reservation: TDR.Reservation;
	basePolicies: TDR.PricingPolicy[];
}): Promise<Partial<TDR.Invoice>> => {
	const tableOverridePolicies = legacyTimeslotsToPricingPolicies(restaurant, [table]);
	const policies = [...tableOverridePolicies, ...basePolicies];
	const existingInvoice = await getReservationInvoice(reservation.id);

	// Booking type is per-scenario: an override can make a table request-only on one date or for one
	// party size and instant on the next. generateInvoice reads it off `tableInfo`, so the raw doc
	// would price a Saturday-only-request booking with the table's weekday default. Resolve against
	// the booking being cancelled -- its own date and party size.
	const effectiveTable = computeEffectiveTable(
		toLuxon(reservation.time, restaurant.timezone || 'UTC'),
		restaurant,
		table,
		{ groupSize: reservation.guests }
	);

	const cancelledReservation: TDR.Reservation = {
		...reservation,
		items: [],
		status: TDR.Reservation.Status.Cancelled
	};

	const cancellationInvoice = generateInvoice(
		restaurant.currency,
		policies,
		cancelledReservation,
		existingInvoice,
		restaurant,
		reservation,
		effectiveTable
	);

	return cancellationInvoice;
};
